import React, { useEffect, useRef, useState } from 'react'
import styled from 'styled-components'

const isMobile = window.innerWidth < 712

export const IsThisAI = ({
  colorMode,
}: {
  colorMode: 'light' | 'dark' | undefined
}) => {
  return (
    <StyledIsThisAI>
      <Question data={Content} wide colorMode={colorMode} />
      <Source>
        Quelle:{' '}
        <a href='https://www.technologyreview.com/2018/11/10/139137/is-this-ai-we-drew-you-a-flowchart-to-work-it-out/'>
          Karen Hao, MIT
        </a>
      </Source>
    </StyledIsThisAI>
  )
}

const Question = ({
  data,
  wide,
  colorMode,
}: {
  data: Entry
  wide?: boolean
  colorMode: 'light' | 'dark' | undefined
}) => {
  const [answer, setAnswer] = useState<number | undefined>()
  const icons = ['see', 'hear', 'read', 'move', 'think']
  const nextElRef = useRef<HTMLDivElement>(null)
  useEffect(() => {
    if (isMobile && !wide)
      nextElRef.current?.scrollIntoView({ behavior: 'smooth' })
  }, [])
  return (
    <>
      <StyledQuestion
        className='question'
        isResult={data.result ? data.result : undefined}
        ref={nextElRef}
        colorMode={colorMode}
      >
        <Label isResult={data.result ? data.result : undefined}>
          {data.label}
        </Label>
        {data.options?.map((m, i) => (
          <Button
            colorMode={colorMode}
            className={wide ? 'wide' : undefined}
            key={Math.random()}
            onClick={() => {
              setAnswer(i)
            }}
            notSelected={answer !== undefined && answer !== i}
          >
            {wide && (
              <div className='image'>
                <svg viewBox='0 0 100 100'>{Icons[icons[i]]}</svg>
              </div>
            )}
            {m[0]}
          </Button>
        ))}
        {data.result && (
          <Result>
            {data.result === 'yes' && (
              <img src={require('./images/brain_01.png')} />
            )}

            <div>
              {data.result === 'yes'
                ? 'Das ist künstliche Intelligenz.'
                : 'Das ist keine künstliche Intelligenz.'}
              {/* : 'Das ist keine künstliche Intelligenz. Die Funktionen basieren auf genauen menschlichen Anweisungen.'} */}
            </div>
            <div>
              {data.result === 'yes' && data.examples && (
                <Examples>
                  <div>Sie kommt zum Beispiel hier zum Einsatz:</div>
                  {data.examples.map((example) => {
                    return (
                      <>
                        <span>{example}</span>
                        <br />
                      </>
                    )
                  })}
                </Examples>
              )}
              {data.result === 'no' && data.examples && (
                <Examples>
                  <div>Wie zum Beispiel hier:</div>
                  {data.examples.map((example) => {
                    return (
                      <>
                        <span>{example}</span>
                        <br />
                      </>
                    )
                  })}
                </Examples>
              )}
            </div>
          </Result>
        )}
      </StyledQuestion>

      {answer !== undefined && (
        <ArrowHolder colorMode={colorMode}>
          <svg width='25px' viewBox='0 0 38 38'>
            <polygon points='0 0 19 26.25 38 0 0 0' />
          </svg>
        </ArrowHolder>
      )}
      {answer !== undefined && data.options && data.options[answer] && (
        <>
          <Question
            data={data.options[answer][1]}
            key={'' + Math.random()}
            colorMode={colorMode}
          />
        </>
      )}
    </>
  )
}

const Examples = styled.div`
  font-weight: 400;
  font-size: 15px;
  margin-top: 30px;
  span {
    font-weight: 700;
  }
  span::after {
    content: ', ';
  }
  span:last-of-type::after {
    content: '';
  }
`
const Source = styled.div`
  font-size: 12px;
  font-weight: 400;
  color: var(--gray-3) !important;
  padding-top: 5px;
  a {
    color: var(--gray-3) !important;
    text-decoration: underline;
  }
`
const ArrowHolder = styled.div<{ colorMode: 'light' | 'dark' | undefined }>`
  position: relative;
  width: 100%;
  height: 25px;
  margin-top: -1px;
  text-align: center;
  svg {
    polygon {
      fill: ${({ colorMode }) =>
        colorMode === 'dark'
          ? 'var(--brandblue-bright-1)'
          : 'var(--brandblue-bright-5)'};
    }
  }
`
const Result = styled.div`
  text-align: center;
  line-height: 1.4em;
  margin-bottom: 10px;
  font-weight: 700;
  img {
    margin: 15px;
    max-width: 160px;
  }
`

const StyledQuestion = styled.div<{
  isResult: 'yes' | 'no' | undefined
  colorMode: 'light' | 'dark' | undefined
}>`
  display: flex;
  flex-wrap: wrap;
  gap: 0px;
  flex: 0 0 100%;
  justify-content: center;
  border-radius: 0px;
  background-color: ${({ isResult, colorMode }) =>
    isResult === 'yes'
      ? 'var(--petrol-main)'
      : isResult === 'no'
      ? 'var(--red-main)'
      : colorMode === 'dark'
      ? 'var(--brandblue-bright-1)'
      : 'var(--brandblue-bright-5)'};
  color: ${({ isResult }) => (isResult ? '#fff' : 'var(--text-color)')};
  padding: ${({ isResult }) => (isResult ? '30px' : '30px')};
  @media only screen and (max-width: 711px) {
    padding: ${({ isResult }) => (isResult ? '20px' : '15px')};
  }
  border-radius: 10px;
`
const Label = styled.div<{ isResult: 'yes' | 'no' | undefined }>`
  flex: 0 0 100%;
  text-align: center;
  line-height: 2em;
  font-weight: ${({ isResult }) => (isResult !== undefined ? '300' : '700')};
  letter-spacing: 0.2px;
  line-height: 1.4em;
  padding-bottom: 15px;
  span {
    font-weight: 300;
    display: inline-block;
    width: 100%;
    font-size: 17px;
  }
`
const Button = styled.button<{
  notSelected: boolean
  colorMode: 'light' | 'dark' | undefined
}>`
  flex: 0 0 20%;
  border: 0;
  border: 1px solid
    ${({ colorMode }) =>
      colorMode === 'dark'
        ? 'var(--brandblue-bright-1)'
        : 'var(--brandblue-bright-5)'};

  padding: 15px;
  padding-left: 10px;
  padding-right: 10px;
  letter-spacing: 1px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  font-size: 18px !important;
  cursor: pointer;
  background-color: ${({ notSelected, colorMode }) =>
    notSelected
      ? colorMode === 'dark'
        ? 'var(--brandblue-bright-2)'
        : '#fff'
      : 'var(--petrol-main)'};
  color: ${({ notSelected, colorMode }) =>
    notSelected
      ? colorMode === 'dark'
        ? 'var(--brandblue-bright-1)'
        : 'var(--brandblue-bright-4)'
      : '#fff'};
  .image {
    padding-top: 10px;
    padding-bottom: 10px;
    flex: 0 0 100%;

    svg {
      width: 60px;
      path {
        fill: ${({ notSelected, colorMode }) =>
          notSelected
            ? colorMode === 'dark'
              ? 'var(--brandblue-bright-1)'
              : 'var(--brandblue-bright-4)'
            : '#fff'};
      }
    }

    @media only screen and (max-width: 711px) {
      flex: 0 0 60px;
      margin-right: 10px;
      padding-top: 0px;
      height: 30px;

      svg {
        height: 40px;
      }
    }
  }

  @media only screen and (min-width: 712px) {
    &:hover {
      opacity: 0.8;
      background-color: var(--brandblue-main);
      color: #fff;
      svg {
        path {
          fill: #fff;
        }
      }
    }
  }

  @media only screen and (max-width: 711px) {
    &.wide {
      justify-content: flex-start;

      flex: 0 0 100%;
    }
  }
`
const StyledIsThisAI = styled.div`
  font-family: var(--font-sans-serif);
  font-weight: 300;
  letter-spacing: 0.4px;
  margin-bottom: 60px;

  padding: 15px;
  padding-left: 0;
  padding-right: 0;
`

const Icons: { [key: string]: string | React.ReactNode } = {
  see: (
    <path
      transform='translate(0,15)'
      d='M49.0776,51.0931c-6.1586,0-11.1512-4.9926-11.1512-11.1512s4.9926-11.1512,11.1512-11.1512c.7393,0,1.4606,.0759,2.1597,.2132-.595,.9709-.9441,2.1087-.9441,3.3308,0,3.53,2.8616,6.3916,6.3916,6.3916,1.2221,0,2.3599-.3491,3.3308-.9441,.1373,.6991,.2132,1.4203,.2132,2.1597,0,6.1586-4.9926,11.1512-11.1512,11.1512Zm49.0781-11.1517l-1.4502,1.6504c-11.748,13.3721-29.1074,21.042-47.6279,21.042S13.1973,54.9639,1.4492,41.5918l-1.4492-1.6504,1.4497-1.6499c11.748-13.3721,29.1079-21.0415,47.6279-21.0415s35.8799,7.6694,47.6279,21.0415l1.4502,1.6499ZM28.3459,53.9986c-2.7283-4.011-4.3254-8.8503-4.3254-14.0562s1.5974-10.0464,4.326-14.0577c-8.2153,2.9962-15.6331,7.7697-21.6302,14.0567,5.9968,6.2871,13.4144,11.0608,21.6296,14.0572Zm5.2498,1.6353c4.9747,1.3076,10.1735,1.9999,15.4819,1.9999s10.5079-.6924,15.4827-2.0001c4.0557-4.002,6.5749-9.5571,6.5749-15.6913s-2.5194-11.6904-6.5754-15.6925c-4.9749-1.3076-10.1738-1.9999-15.4822-1.9999s-10.5068,.6923-15.4813,1.9996c-4.0562,4.0021-6.5758,9.5579-6.5758,15.6927s2.5194,11.6896,6.5752,15.6915Zm36.214-1.6353c8.2151-2.9964,15.6325-7.7701,21.6293-14.0572-5.9968-6.2869-13.4146-11.0602-21.6298-14.0565,2.7286,4.0113,4.3261,8.851,4.3261,14.0574s-1.5972,10.0452-4.3256,14.0562ZM51.5776,13.5V.0333c-.832-.0162-1.6638-.0333-2.5-.0333s-1.668,.017-2.5,.0333V13.5h5Zm-14.3883,.8512L29.7617,1.486c-1.7599,.2723-3.5052,.5836-5.2375,.9282l7.425,12.8607c1.7253-.3629,3.4731-.67,5.2402-.9236ZM73.6309,2.4141c-1.7323-.3447-3.4777-.6558-5.2376-.9281l-7.4278,12.8652c1.7671,.2535,3.5149,.5607,5.2402,.9236l7.4252-12.8607Z'
    />
  ),
  read: (
    <path
      transform='translate(0,5)'
      d='M95.5974,5.7287c-30.8252,0-42.4121,4.5518-46.499,7.1255-1.4043-.9004-3.7012-2.0288-7.3926-3.124C32.7546,7.0749,19.5837,5.7287,2.5583,5.7287H.0583V69.756H2.5583c35.7939,0,43.8271,6.2227,44.5693,6.875l1.8047,3.3555,2.0869-3.3477c.6855-.6094,8.6377-6.8828,44.5781-6.8828h2.5V5.7287h-2.5ZM5.0583,57.1752c36.7712,.3085,43.1808,7.339,43.2295,7.3953l.7695,.958,.7969-.9414c.0621-.0726,6.4719-7.1034,43.2432-7.4119v2.6519c-31.7048,.2631-41.468,5.4766-44.0195,7.4417-2.5516-1.9651-12.3148-7.1786-44.0195-7.4417v-2.6519ZM93.0974,10.739V55.173c-28.5372,.2362-39.2939,4.4829-43.0195,6.7632V19.2287h-.0666l1.008-1.6167c.6689-.5957,8.2656-6.5903,42.0781-6.873Zm-45.9697,6.8652l.9502,1.7664V61.9362c-3.7256-2.2803-14.4823-6.527-43.0195-6.7632V10.739c33.6709,.2817,41.3447,6.2275,42.0693,6.8652Zm1.9707,54.2778c-1.4043-.9014-3.7012-2.0293-7.3926-3.124-8.5078-2.5244-20.8281-3.8652-36.6475-3.9922v-2.9383c36.7712,.3085,43.1808,7.339,43.2295,7.3953l.7695,.958,.7969-.9414c.0621-.0726,6.4719-7.1034,43.2432-7.4119v2.9383c-28.9551,.2393-40.0244,4.6123-43.999,7.1162Z'
    />
  ),
  hear: (
    <path d='M75.4246,33.2722c0-6.0654-4.9346-11-11-11s-11,4.9346-11,11h-2c0-7.1685,5.832-13,13-13s13,5.8315,13,13-5.832,13.0005-13,13.0005c-3.375,0-6.1201,2.7451-6.1201,6.1201h-2c0-4.4775,3.6426-8.1201,8.1201-8.1201,6.0654,0,11-4.9346,11-11.0005Zm17.3193,0c0-15.6157-12.7041-28.3198-28.3193-28.3198-11.3501,0-21.1562,6.7142-25.67,16.3766,1.1883,1.9417,2.2271,3.9626,3.1054,6.0513,2.6172-10.0149,11.7411-17.4279,22.5646-17.4279,12.8584,0,23.3193,10.4614,23.3193,23.3198,0,11.686-8.7236,21.6274-20.292,23.1255l-3.2656,.4229,1.2852,3.0322c.5039,1.1895,1.5449,4.0977,1.5449,5.5,0,5.7402-4.6699,10.4102-10.4102,10.4102s-10.4092-4.6699-10.4092-10.4102h-5c0,8.4971,6.9121,15.4102,15.4092,15.4102s15.4102-6.9131,15.4102-15.4102c0-1.3838-.4287-3.1123-.8848-4.5596,12.5146-3.041,21.6123-14.3721,21.6123-27.521ZM22.158,22.7272c5.9619,5.9629,9.2461,13.8901,9.2461,22.3218s-3.2842,16.3594-9.2461,22.3223l3.5352,3.5352c6.9072-6.9072,10.7109-16.0898,10.7109-25.8574s-3.8037-18.9502-10.7109-25.8569l-3.5352,3.5352Zm-5.7656,5.7651l-3.5352,3.5361c3.4785,3.4775,5.3936,8.1016,5.3936,13.0205s-1.916,9.543-5.3936,13.0215l3.5352,3.5352c4.4229-4.4229,6.8584-10.3027,6.8584-16.5566s-2.4355-12.1343-6.8584-16.5566Zm-10.9805,10.9814c1.4893,1.4888,2.3096,3.4688,2.3096,5.5752s-.8203,4.0869-2.3096,5.5762l3.5352,3.5352c2.4336-2.4336,3.7744-5.6699,3.7744-9.1113s-1.3408-6.6777-3.7744-9.1113l-3.5352,3.5361Z' />
  ),
  move: (
    <path d='M96.0525,48.0263l-19.7123-15.9216v13.4216h-14.5308c-.9882-5.8509-5.5014-10.5193-11.2831-11.7064v-14.1075h13.4216L48.0262,0l-15.9216,19.7124h13.4216v13.9847c-6.159,.9059-11.0518,5.7125-12.0848,11.8292h-13.7291v-13.4216L0,48.0262l19.7123,15.9217v-13.4216h13.7594c1.1041,6.0233,5.9617,10.7349,12.0545,11.631v14.1829h-13.4216l15.9216,19.7124,15.9216-19.7124h-13.4216v-14.3057c5.7167-1.1736,10.1973-5.7495,11.2527-11.5082h14.5612v13.4216l19.7123-15.9216Zm-39.0262-.0991c0,.9024-.1351,1.7725-.3735,2.5991-.8636,2.9947-3.1741,5.3782-6.1265,6.3388-.9145,.2975-1.8879,.463-2.9004,.463-.7226,0-1.4233-.0897-2.0996-.2448-3.3304-.7637-5.9879-3.2967-6.9282-6.5569-.2385-.8267-.3735-1.6967-.3735-2.5991,0-.831,.1191-1.6329,.3224-2.4009,.8885-3.3546,3.5822-5.976,6.9793-6.7552,.6763-.1551,1.377-.2448,2.0996-.2448,1.0125,0,1.9859,.1654,2.9004,.463,3.0168,.9817,5.3602,3.4504,6.1776,6.537,.2034,.7679,.3224,1.5699,.3224,2.4009Z' />
  ),
  think: (
    <path d='M96.3706,40.6699c0-3.9243-2.3096-7.4375-5.7114-9.1406,.2642-.9131,.4002-1.8647,.4002-2.8325,0-4.7935-3.3426-8.8281-7.8396-9.936,.0197-.2607,.0296-.5229,.0296-.7866,0-5.645-4.6359-10.2373-10.3335-10.2373-.4367,0-.8734,.0283-1.3071,.0835-1.0991-4.4824-5.185-7.8203-10.0427-7.8203-5.6976,0-10.3335,4.5923-10.3335,10.2368v60.8657c0,5.6445,4.6359,10.2373,10.3335,10.2373,4.8577,0,8.9436-3.3379,10.0427-7.8203,.4337,.0547,.8704,.083,1.3071,.083,5.6976,0,10.3335-4.5928,10.3335-10.2373,0-.2637-.0099-.5264-.0296-.7871,4.4969-1.1074,7.8396-5.1416,7.8396-9.9355,0-.9678-.136-1.9189-.4002-2.832,3.4018-1.7031,5.7114-5.2158,5.7114-9.1406Zm-9.5459,5.1699c-.8576,.127-1.589,.6816-1.937,1.4688-.349,.7861-.2652,1.6953,.2218,2.4062,.5905,.8643,.9029,1.877,.9029,2.9277,0,2.8877-2.3717,5.2373-5.2865,5.2373-.1419,0-.2819-.0117-.4219-.0225-.8832-.0635-1.729,.3252-2.2435,1.0332-.5146,.709-.6181,1.6328-.273,2.4365,.275,.6426,.415,1.3281,.415,2.0381,0,2.8877-2.3717,5.2373-5.2865,5.2373-.8517,0-1.6689-.1982-2.4289-.5898-.826-.4258-1.8226-.3652-2.5925,.1562-.7679,.5225-1.1839,1.4229-1.0794,2.3408,.0217,.1953,.0375,.3926,.0375,.5928,0,2.8877-2.3717,5.2373-5.2865,5.2373s-5.2865-2.3496-5.2865-5.2373v-12.9266c1.6188,1.8708,4.016,3.0623,6.6922,3.0623,4.8626,0,8.8194-3.9199,8.8194-8.7373h-2.0188c0,3.7148-3.0509,6.7373-6.8006,6.7373-3.3491,0-6.1339-2.4133-6.6922-5.5754V10.2368c0-2.8877,2.3717-5.2368,5.2865-5.2368s5.2865,2.3491,5.2865,5.2368c0,.2007-.0148,.3979-.0375,.5923-.1045,.9175,.3105,1.8174,1.0784,2.3403,.7689,.5229,1.7655,.583,2.5925,.1582,.762-.3921,1.5792-.5908,2.4298-.5908,2.9148,0,5.2865,2.3496,5.2865,5.2373,0,.71-.14,1.3965-.416,2.04-.344,.8047-.2395,1.729,.276,2.4385,.5165,.708,1.3623,1.0996,2.2475,1.0303,.138-.0107,.276-.0234,.416-.0234,2.9148,0,5.2865,2.3496,5.2865,5.2373,0,1.0518-.3125,2.064-.9029,2.9282-.487,.7114-.5707,1.6201-.2218,2.4067,.348,.7866,1.0794,1.3408,1.937,1.4683,2.5649,.3799,4.4989,2.6025,4.4989,5.1699s-1.934,4.79-4.4989,5.1699Zm-6.426-1.5508h-2.0188c0-3.7148-3.0509-6.7373-6.8006-6.7373s-6.8006,3.0225-6.8006,6.7373h-2.0188c0-4.8179,3.9567-8.7373,8.8194-8.7373s8.8194,3.9194,8.8194,8.7373Zm-16.3011-26.3149h2.0188c0,3.7148,3.0499,6.7373,6.7996,6.7373v2c-4.8626,0-8.8184-3.9194-8.8184-8.7373ZM34.8044,0c-4.8577,0-8.9436,3.3379-10.0427,7.8203-.4337-.0552-.8704-.0835-1.3081-.0835-5.6976,0-10.3335,4.5923-10.3335,10.2373,0,.2637,.0099,.5264,.0296,.7871-4.4969,1.1079-7.8386,5.1421-7.8386,9.9355,0,.9673,.136,1.9189,.4002,2.8325-3.4018,1.7026-5.7114,5.2158-5.7114,9.1406s2.3096,7.4375,5.7114,9.1406c-.2642,.9131-.4002,1.8643-.4002,2.832,0,4.793,3.3426,8.8281,7.8386,9.9355-.0197,.2607-.0296,.5234-.0296,.7871,0,5.6445,4.6359,10.2373,10.3335,10.2373,.4377,0,.8743-.0283,1.3081-.084,1.0991,4.4834,5.185,7.8213,10.0427,7.8213,5.6976,0,10.3335-4.5928,10.3335-10.2373V10.2368c0-5.6445-4.6359-10.2368-10.3335-10.2368Zm0,76.3398c-2.9148,0-5.2865-2.3496-5.2865-5.2373,0-.2031,.0158-.4033,.0375-.6016,.1005-.917-.3164-1.8145-1.0843-2.334-.4278-.29-.9256-.4365-1.4244-.4365-.3992,0-.7984,.0938-1.1651,.2822-.759,.3916-1.5752,.5898-2.4279,.5898-2.9148,0-5.2865-2.3496-5.2865-5.2373,0-.708,.14-1.3945,.416-2.04,.344-.8047,.2395-1.7275-.275-2.4355-.5146-.709-1.3731-1.0947-2.2435-1.0322-.139,.0107-.279,.0225-.4209,.0225-2.9148,0-5.2855-2.3496-5.2855-5.2373,0-1.0508,.3125-2.0645,.9029-2.9287,.486-.7119,.5698-1.6201,.2208-2.4062-.348-.7861-1.0794-1.3408-1.937-1.4678-2.5639-.3799-4.4979-2.6025-4.4979-5.1699s1.933-4.7896,4.4979-5.1694c.8566-.127,1.588-.6812,1.937-1.4673,.348-.7861,.2652-1.6948-.2208-2.4062-.5905-.8652-.9029-1.8789-.9029-2.9302,0-2.8877,2.3707-5.2368,5.2855-5.2368,.14,0,.278,.0117,.415,.0229,.8734,.0688,1.731-.3203,2.2475-1.0293,.5165-.7085,.621-1.6328,.277-2.4375-.276-.6465-.416-1.3335-.416-2.042,0-2.8877,2.3717-5.2373,5.2865-5.2373,.8507,0,1.6689,.1987,2.4289,.5903,.826,.4238,1.8197,.3652,2.5895-.1553,.7679-.5205,1.1839-1.418,1.0833-2.3345-.0217-.1973-.0375-.397-.0375-.6006,0-2.8877,2.3717-5.2368,5.2865-5.2368s5.2865,2.3491,5.2865,5.2368v12.9269c-1.6188-1.8707-4.016-3.0621-6.6922-3.0621-4.8626,0-8.8194,3.9194-8.8194,8.7373h2.0188c0-3.7148,3.0509-6.7373,6.8006-6.7373,3.3491,0,6.1339,2.4133,6.6922,5.5754v43.4256c0,2.8877-2.3717,5.2373-5.2865,5.2373Zm-3.2125-39.2891h2.0188c0,4.8174-3.9567,8.7373-8.8194,8.7373s-8.8194-3.9199-8.8194-8.7373h2.0188c0,3.7148,3.0509,6.7373,6.8006,6.7373s6.8006-3.0225,6.8006-6.7373Zm.6811,26.3145h-2.0188c0-3.7148-3.0509-6.7363-6.8006-6.7363v-2c4.8626,0,8.8194,3.9189,8.8194,8.7363Z' />
  ),
}

type Entry = {
  label: string | React.ReactNode
  options?: [string, Entry][]
  result?: 'yes' | 'no'
  examples?: string[]
}
const Content: Entry = {
  label: 'Diese Anwendung kann …',
  options: [
    [
      'Sehen',
      {
        label: 'Kann sie identifizieren, was sie sieht?',
        options: [
          [
            'Ja',
            {
              label:
                'Diese Anwendung benutzt Computer Vision und Image Processing.',
              result: 'yes',
              examples: [
                'Intelligente Webcams',
                'Überwachungssysteme',
                'Echtzeit-Tracking beim Fussball',
              ],
            },
          ],
          [
            'Nein',
            {
              label: 'Dann ist es vermutlich einfach eine Kamera.',
              result: 'no',
            },
          ],
        ],
      },
    ],
    [
      'Hören',
      {
        label: (
          <>
            Antwortet sie in einer nützlichen und sinnvollen Art und Weise?{' '}
            <span>
              Die Reaktion sollte direkt auf das Gehörte Bezug nehmen und nicht
              aus sich wiederholenden und beliebigen Phrasen bestehen.
            </span>
          </>
        ),
        options: [
          [
            'Ja',
            {
              label: 'Dann ist es Natural Language Processing.',
              result: 'yes',
              examples: ['Chatbot', 'Textgeneratoren wie GPT-3'],
            },
          ],
          [
            'Nein',
            {
              label: (
                <>
                  Transkribiert sie, was du sagst?
                  <span>
                    Das heisst sie wandelt das von dir Gesprochene in
                    geschriebenen Text um?
                  </span>
                </>
              ),
              options: [
                [
                  'Ja',
                  {
                    label: 'Dann ist es Spracherkennung.',
                    result: 'yes',
                    examples: ['Automatische Untertitel in Videos'],
                  },
                ],
                [
                  'Nein',
                  {
                    label: 'Dann ist es einfach ein Mikrofon.',
                    result: 'no',
                  },
                ],
              ],
            },
          ],
        ],
      },
    ],
    [
      'Lesen',
      {
        label: 'Liest sie, was du eintippst?',
        options: [
          [
            'Ja',
            {
              label: (
                <>
                  Antwortet sie in einer nützlichen und sinnvollen Art und Weise?{' '}
                  <span>
                    Die Reaktion sollte direkt auf das Gehörte Bezug nehmen und
                    nicht aus sich wiederholenden und beliebigen Phrasen
                    bestehen.
                  </span>
                </>
              ),
              options: [
                [
                  'Ja',
                  {
                    label: 'Dann ist es Spracherkennung',
                    result: 'yes',
                    examples: [
                      'Smart Speaker',
                      'Siri bzw. Alexa',
                      'Voicebot beim Kundenservice',
                    ],
                  },
                ],
                [
                  'Nein',
                  {
                    label: 'Dann ist es einfach ein Textverarbeitungsprogramm.',
                    result: 'no',
                  },
                ],
              ],
            },
          ],
          [
            'Nein',
            {
              label: 'Liest sie Textabschnitte?',
              options: [
                [
                  'Ja',
                  {
                    label: 'Analysiert sie darin Muster?',
                    options: [
                      [
                        'Ja',
                        {
                          label: 'Dann ist es Spracherkennung.',
                          result: 'yes',
                          examples: ['Chatbot', 'Textgeneratoren wie GPT-3'],
                        },
                      ],
                      [
                        'Nein',
                        {
                          label: 'Dann liest sie nur zum Spass?',
                          result: 'no',
                        },
                      ],
                    ],
                  },
                ],
                ['Nein', { label: 'Was liest sie denn dann?', result: 'no' }],
              ],
            },
          ],
        ],
      },
    ],
    [
      'Sich bewegen',
      {
        label: 'Von allein ohne Hilfe?',
        options: [
          [
            'Ja',
            {
              label:
                'Bewegt sie sich basierend auf dem, was sie sieht und hört?',
              options: [
                [
                  'Ja',
                  {
                    label: (
                      <>
                        Bist du sicher, dass sie sich nicht nur auf einem
                        programmierten Weg bewegt?{' '}
                        <span>
                          Sie folgt dabei also keiner sich wiederholenden Route.
                        </span>
                      </>
                    ),
                    options: [
                      [
                        'Ja',
                        {
                          label: 'Ok. Es ist ein intelligenter Roboter.',
                          result: 'yes',
                          examples: [
                            'Staubsauger-Roboter der neuen Generation',
                            'Selbstfahrende Autos',
                            'Modernen Hobby-Drohnen',
                          ],
                        },
                      ],
                      [
                        'Nein',
                        {
                          label: 'Das ist kein intelligenter Roboter.',
                          result: 'no',
                          examples: [
                            'Staubsauger-Roboter der alten Generation',
                            'Programmierbare Spielzeuge',
                          ],
                        },
                      ],
                    ],
                  },
                ],
                [
                  'Nein',
                  {
                    label: 'Das ist kein intelligenter Roboter.',
                    result: 'no',
                    examples: ['Ferngesteuertes Spielzeug', 'Turmdrehkran'],
                  },
                ],
              ],
            },
          ],
          ['Nein', { label: '', result: 'no' }],
        ],
      },
    ],
    [
      'Logisch Denken',
      {
        label: (
          <>
            Sucht sie nach Mustern in riesigen Datenmengen?
            <span>
              Versucht sie also Ähnlichkeiten und Wiederholungen in den Eingaben
              zu finden?
            </span>
          </>
        ),
        options: [
          [
            'Ja',
            {
              label: (
                <>
                  Nutzt sie diese Muster, um Entscheidungen zu treffen?
                  <span>
                    Das heisst sie orientiert ihr Verhalten an ähnlichen
                    Eingaben und passt ihre Reaktion an.
                  </span>
                </>
              ),
              options: [
                [
                  'Ja',
                  {
                    label: 'Das ist maschinelles Lernen.',
                    result: 'yes',
                    examples: [
                      'GPT-3',
                      'IBM Watson',
                      'Siri, Alexa, Google Assistant',
                    ],
                  },
                ],
                [
                  'Nein',
                  { label: 'Hmmm...das klingt nach Mathematik.', result: 'no' },
                ],
              ],
            },
          ],
          [
            'Nein',
            { label: 'Das klingt nicht nach logischem denken.', result: 'no' },
          ],
        ],
      },
    ],
  ],
}
